import { Button, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { acceptCall, endCall } from '../../../store/dialer';
import { useAppDispatch } from '../../../store/hooks';

export default function IncomingCallControls() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    //const handleAcceptCall = () => {
    //    dispatch(twilioActions.acceptCall());
    //}

    const handleAccept = () => {
        dispatch(acceptCall());
    };

    const handleDecline = () => {
        dispatch(endCall());
    };

    return (
        <Grid container direction="row" wrap="nowrap" alignItems="center" spacing={1}>
            <Grid item xs="auto" className={classes.buttonWrapperPrimary}>
                <Button variant="contained" color="success" onClick={handleAccept}>
                    Accept
                </Button>
            </Grid>
            <Grid item xs="auto" className={classes.buttonWrapperPrimary}>
                <Button variant="contained" color="error" onClick={handleDecline}>
                    Ignore
                </Button>
            </Grid>
            <Grid item xs="auto" className={classes.buttonWrapperPrimary}></Grid>
        </Grid>
    );
}
const useStyles = makeStyles()({
    buttonWrapperPrimary: {
        '& .MuiIconButton-root': {
            padding: '6px',
        },
    },
});
